/*    
<summary>
  This functional component "AbortPopupHOC" provides props to the child component.
  1. State "showAbortPopup" that manages the show/hide of pop up
  2. Function "abortPopupToggleHandler" to toggle the show/hide popup state "showAbortPopup"
  Developer:Aashish Singh, Created Date:04-July-2025
</summary>
<returns>Returns JSX</returns>
*/

import React, {useState } from 'react';

const AbortPopupHOC = (Component:any) => 
function Comp(props:any){
    const [showAbortPopup,setShowAbortPopup] = useState<boolean>(false);

    const abortToggleHandler = () => {
        setShowAbortPopup(!showAbortPopup);
    }
    
    return <Component showAbortPopup={showAbortPopup} abortPopupToggleHandler={abortToggleHandler} {...props}/>;
};

export default AbortPopupHOC;   